const BASE_URL = '/api/item/'

export const useItem = () => {
  const { fetchGet, fetchPost } = useCustomFetch()
  const { isWebParts } = useWebParts()

  function getItem(id: string): Promise<Item> {
    return fetchGet(BASE_URL + (isWebParts.value ? '/' : 'so/') + id)
  }

  function getTestItem(id: string): Promise<Item> {
    return fetchGet(BASE_URL + (isWebParts.value ? '/' : 'so/') + id + '?test=true')
  }

  function putImageFeature(feature: number[]): Promise<string> {
    return fetchPost(BASE_URL + 'create-image-feature', feature)
  }

  function testCustomSearch(
    def: any,
    test?: boolean,
    type: APICallType = 'M',
  ): (q: SearchQuery) => Promise<SearchResult<Item>> {
    return (q: SearchQuery) => {
      return fetchPost(BASE_URL + 'test-custom-search?jps-act=' + type, {
        def,
        q,
        test,
      })
    }
  }

  function update(item: Item): Promise<Item> {
    return fetchPost(BASE_URL + 'update', item)
  }

  function getSearchId(
    csId: string,
    test?: boolean,
  ): (q: SearchQuery) => Promise<SearchResult<Item>> {
    return (q: SearchQuery) => {
      return fetchGet<SearchResult<Item>>(
        BASE_URL +
        (isWebParts.value ? 'search/' : 'search-so/') +
        csId +
        toSearchQueryString(q) +
        (test ? '&test=true' : ''),
      )
    }
  }

  function getSearchCs(
    cs: CustomSearchDefinition,
    test?: boolean,
  ): (q: SearchQuery) => Promise<SearchResult<Item>> {
    return (q: SearchQuery) => {
      return fetchGet<SearchResult<Item>>(
        BASE_URL +
        (isWebParts.value ? 'search/' : 'search-so/') +
        cs.id +
        toSearchQueryString(q) +
        (test ? '&test=true' : ''),
      )
    }
  }

  return {
    getItem,
    getTestItem,
    putImageFeature,
    testCustomSearch,
    update,
    getSearchId,
    getSearchCs,
  }
}
